import { render, staticRenderFns } from "./ordenTrabajoResultados.vue?vue&type=template&id=387832a7"
import script from "./ordenTrabajoResultados.vue?vue&type=script&lang=js"
export * from "./ordenTrabajoResultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports